import React from 'react';

import Heading from 'buyside/components/presentation/ContributorDashboard/contributorDashboardHeading';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import SubmitResearchButton from 'buyside/components/presentation/Button/SubmitResearchButton/submitResearchButton';
import ResearchItem, {
  ResearchTypes
} from 'buyside/components/presentation/ResearchItem/researchItem';

import { useCurrentUserPublishedWhitePapersQuery } from 'interfaces/graphql-typings';

import { newMacroThematicUrl } from 'buyside/util/urlHelper';

import styles from 'buyside/components/presentation/ContributorDashboard/contributorDashboardStyles.scss';

export const whitePaperHeading = 'Macro/thematic papers';

const MyWhitePapers: React.FC = () => {
  const { error, data, loading } = useCurrentUserPublishedWhitePapersQuery();

  if (loading)
    return (
      <>
        <Heading title={whitePaperHeading} />
        <LoadingSpinner size={SIZES.LARGE} />
      </>
    );
  if (error) throw error;
  if (!data || !data.currentUser) return null;

  const { canWriteWhitePapers, whitePapers } = data.currentUser;

  return (
    <>
      <Heading title={whitePaperHeading}>
        {canWriteWhitePapers ? <SubmitResearchButton url={newMacroThematicUrl()} /> : null}
      </Heading>
      {whitePapers?.length ? (
        <div>
          {whitePapers.map(paper => {
            if (!paper) return null;
            return (
              <ResearchItem
                {...paper}
                key={paper.id}
                researchType={ResearchTypes.WHITE_PAPER}
                showUserDetails
              />
            );
          })}
        </div>
      ) : (
        <div className={styles.noContentMsg}>
          <p>
            SumZero’s Macro/Thematic submission flow is meant to provide you another outlet for any
            content that you might be sharing elsewhere (e.g., your website, mailing lists) that
            isn’t tied to an individual stock or target price. Its purpose is to allow you to
            leverage SumZero and our built-in buyside and allocator network as another exposure
            engine for you and your fund with more regularity.
          </p>
          <p>
            *Upon submission, you have the option of allowing this content to flow directly to your
            SumZero Cap Intro fund profile as well.
          </p>
          <p>
            Contact your rep or{' '}
            <strong>
              <a href="access@sumzero.com">access@sumzero.com</a>
            </strong>{' '}
            to discuss how others are leveraging this tool and how we can help you bring more
            exposure to the work you’re doing.
          </p>
        </div>
      )}
    </>
  );
};

export default MyWhitePapers;
